<template>
  <form class="needs-validation" @submit.prevent="submitBlock" novalidate>
    <input type="hidden" id="id" v-model="newBlock.id">
    <fieldset class="form-row mb-4">
      <label class="col-12 mb-3">1. Select your card style</label>
      <div class="d-flex flex-wrap align-items-end">
        <div class="custom-control custom-radio custom-control-inline flex-wrap mb-2">
          <label for="styleA" class="w-100 mb-3 d-flex align-items-center justify-content-center" style="height: 100px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 142.3 119.9" height="100" aria-labelledby="stylea" class="styleNudge"><title id="stylea">Style A</title><g transform="translate(-672 -267)"><g transform="translate(672 267)"><path fill="#f2f3f4" d="M5 0h132.3a5 5 0 0 1 5 5v43.2H0V5a5 5 0 0 1 5-5z"/></g><g transform="translate(672 314.6)"><g fill="none" stroke="#e0e0e0"><path stroke="none" d="M5 0h132.3a5 5 0 0 1 5 5v67.3H0V5a5 5 0 0 1 5-5z" transform="rotate(180 71.2 36.2)"/><path d="M5 .5h132.3a4.5 4.5 0 0 1 4.5 4.5v66.3a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V5A4.5 4.5 0 0 1 5 .5z" transform="rotate(180 71.2 36.2)"/></g></g><path d="M0 0h94.3v6H0z" fill="#a2a0a0" transform="translate(696 333)"/><path d="M0 0h94.3v6H0z" fill="#a2a0a0" transform="translate(696 344)"/><path d="M0 0h94.3v6H0z" fill="#a2a0a0" transform="translate(696 355)"/></g></svg>
          </label>
          <input class="custom-control-input" type="radio" name="paymentMethod" id="styleA" value="A" checked="" v-model="newBlock.style">
          <label class="custom-control-label font-weight-normal text-nowrap" for="styleA">Style A</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline flex-wrap mb-2">
          <label for="styleB" class="w-100 mb-3 d-flex align-items-center justify-content-center" style="height: 100px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 142.3 119.9" height="100" aria-labelledby="styleb" class="styleNudge"><title id="stylea">Style B</title><path id="_3ed56ded9ef27dcaae8064def0d86512" fill="#f2f3f4" d="M5 0h132.3a5 5 0 0 1 5 5v109.9a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5z"/><path id="Rectangle_1873" d="M24 46h94.3v6H24z" fill="#a2a0a0"/><path id="Rectangle_1874" d="M24 57h94.3v6H24z" fill="#a2a0a0"/><path id="Rectangle_1875" d="M24 68h94.3v6H24z" fill="#a2a0a0"/></svg>
          </label>
          <input class="custom-control-input" type="radio" name="paymentMethod" id="styleB" value="B" v-model="newBlock.style">
          <label class="custom-control-label font-weight-normal text-nowrap" for="styleB">Style B</label>
        </div>
      </div>
    </fieldset>

    <fieldset class="form-row">
      <label class="col-12 mb-3">2. Add your content</label>
      <div class="form-group col-12">
        <label for="title">Title <small>(optional)</small></label>
        <input type="text" class="form-control" id="title" v-model="newBlock.title" placeholder="Type the main title here">
        <div class="invalid-feedback">Please add your title</div>
      </div>
      
      <div class="form-group col-12">
        <label for="text">Text <small>(optional)</small></label>
        <input type="text" class="form-control" id="text" maxlength="142" v-model="newBlock.text">
        <div class="invalid-feedback">Please add your text</div>
        <small>(Content is limited to 142 characters)</small>
      </div>

      <div class="form-group col-12">
        <label for="image">Image</label>
        <div class="custom-file">
          <input type="file" class="custom-file-input font-weight-normal" id="image" accept="image/*" :required="!existingBlock" ref="image" @change="fileUpload">
          <label class="custom-file-label font-weight-normal" for="image">{{newBlock.image ? fileName : 'Choose file...'}}</label>
          <div class="invalid-feedback">Please select an image</div>
        </div>
        <div class="border border-light rounded p-3 mt-2" v-if="newBlock.image">
          <img :src="newBlock.image" class="img-fluid">
        </div>
      </div>
      <div class="form-group col-12">
        <label for="link">Link Destination <small>(optional)</small></label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">https://</div>
          </div>
          <input type="text" class="form-control" id="link" v-model="newBlock.link">
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <button :class="['btn ml-2', processing ? 'btn-primary-dark' : 'btn-primary']" type="submit" @click="handleSubmit">
          {{ !processing ? 'Confirm' : '' }}
          <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
        </button>
      </div>
    </fieldset>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'

export default {
  name: 'DashboardForm',
  props: ['existingBlock'],
  mixins: [HANDLESUBMIT],
  data() {
    return {
      newBlock: this.existingBlock ? this.existingBlock : { image: '', style: 'A' },
      fileName: '',
      processing: false
    }
  },
  mounted() {
    if (this.newBlock.image !== '') {
      this.fileName = this.newBlock.image
      this.newBlock.link = this.newBlock.link.replace('https://', '')
    }
  },
  methods: {
    submitBlock() {
      setTimeout(() => {
        if (this.formComplete) {
          const sendBlock = this.newBlock
          if (sendBlock.link) {
            sendBlock.link = sendBlock.link.replace('https://', '')
            sendBlock.link = sendBlock.link.replace('http://', '')
            sendBlock.link = sendBlock.link.replace('://', '')
            sendBlock.link = sendBlock.link.replace('//', '')
            sendBlock.link = sendBlock.link.replace(/^/, 'https://')
          }
          const formData = new FormData()
          formData.append('file', this.newBlock.file)
          formData.append('fields', JSON.stringify(sendBlock))
          this.processing = true
          axios.post(`${this.$api}/admin/block-create`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(() => {
            // eslint-disable-next-line
            // console.log(response)
            this.processing = false
            this.$emit('submitBlock', this.newBlock)
          }).catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.processing = false
          })
        }
      }, 10)
    },
    fileUpload(event) {
      const uploadedFile = event.target.files[0]
      this.newBlock.file = uploadedFile
      this.newBlock.image = URL.createObjectURL(uploadedFile)
      this.fileName = uploadedFile.name
    }
  }
}
</script>

<style scoped>
.styleNudge {
  transform: translateX(-3.25rem);
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/DashboardForm.vue